import './Header.scss';
import React, { useState } from 'react';
import propTypes from 'prop-types';
import { Link } from "react-router-dom";
import Appmenu from './Appmenu';
import SidebarToggle from './SidebarToggle';
import { buildUrl } from "../../utils/helper";
import { SafeSVG } from '../../svg/SafeSVG';
/**
 * Header component
 * @module
 * @param {string} sidebarType - Sidebar type ('normal','compact','fullscreen')
 * @param {func} onClick - Function invoked on click
 * @param {object} [sideBarToggleIcons] - Sidebar toggle icons
 * @param {element} brand - Brand component 
 */

const Header = props => {
  const [isOpen, setIsOpen] = useState(false);

  const handleAppmenu = () => setIsOpen(!isOpen);
  const handleCloseAppmenu = () => setIsOpen(false);

  return (
    <div>
      <div className="header navbar">
        <div
          style={
            props.sidebarType === 'compact' ? { display: "none" } : { display: "inline-block" }}
          onClick={handleAppmenu}>
          <SafeSVG alt="Aplikácie" src={buildUrl("assets/icons/app-icon.svg")} />
        </div>
        <Link className='header-title' to={"/"} >{props.brand}</Link>
        <SidebarToggle
          sidebarType={props.sidebarType}
          onClick={props.onClick}
          sideBarToggleIcons={props.sideBarToggleIcons}
        />
      </div>
      <Appmenu sidebarType={props.sidebarType} isOpen={isOpen} handleCloseAppmenu={handleCloseAppmenu} />
    </div>
  );
};

Header.propTypes = {
  sidebarType: propTypes.oneOf([
    'normal',
    'compact',
    'fullscreen',
  ]),
  onClick: propTypes.func.isRequired,
  sideBarToggleIcons: propTypes.object,
  brand: propTypes.element
};

export default Header;